// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__g1yVD"};